export const TABLE_COLUMNS = [
  {
    Header: "Date Created",
    accessor: "created_at",
    Cell: ({ row }) => {
      return row.original.created_at ? new Date(row.original.created_at).toLocaleDateString("en-us") : "";
    },
  },
  {
    Header: "Program Name",
    accessor: "program_name",
  },
  {
    Header: "Award Level",
    accessor: "award_level",
  },
  {
    Header: "Event",
    accessor: "event_name",
  },
  {
    Header: "External ID",
    accessor: "participant_organization_uid",
  },
  {
    Header: "To",
    accessor: "recipient_full_name",
  },
  {
    Header: "Email Address",
    accessor: "participant_email",
  },
  {
    Header: "Submitted By",
    accessor: "awarder_full_name",
  },
  {
    Header: "Approval Level",
    accessor: "position_title",
  },
  {
    Header: "Action By",
    accessor: "approved_by",
  },
  {
    Header: "Reference",
    accessor: "referrer",
  },
  {
    Header: "Notes",
    accessor: "notes",
  },
  {
    Header: "Value",
    accessor: "points",
    Cell: ({ row }) => {
      return row.original.points != null ? Number(row.original.points).toFixed(2) : "";
    },
  },
  {
    Header: "Dollar Value",
    accessor: "dollar_value",
    Cell: ({ row }) => {
      return row.original.dollar_value != null ? `$${Number(row.original.dollar_value).toFixed(2)}` : "";
    },
  },
  {
    Header: "Scheduled Date",
    accessor: "scheduled_date",
    Cell: ({ row }) => {
      return row.original.scheduled_date ? new Date(row.original.scheduled_date).toLocaleDateString("en-us") : "";
    },
  },
  {
    Header: "Status",
    accessor: "approval_status",
  },
];
